<template>
  <div id="app">
    <!-- <Header></Header> -->
    <!-- <Nav class="nav-1" v-if="getNav == '0'"></Nav> -->
    <!-- <Navs v-if="getNav == '1'"></Navs> -->
      <router-view/>
  </div>
</template>

<script>
import Header from './components/header'
import Nav from './components/nav'
import Navs from './components/nav2'

export default {
  name: 'App',
  components:{
    Header,Nav,Navs
  },
  data(){
    return{

    }
  },
  computed: {
    getNav() {
      return this.$store.getters.getNavStatus;
    }
  },
  created(){
    this.getDetail();
  },
  methods:{
    getDetail(){
      // AccountApi.getDetail().then((re)=>{
      //   let page = window.location.pathname;
      //   if(!re.data.isAuth){
      //     this.$router.push('/account');
      //     return;
      //   }
      //   if(this.getNav == 0 && page== '/admin.html'){
      //     this.$router.push('/home');
      //     return;
      //   }
      // });
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  /* position: relative; */
}

</style>



// WEBPACK FOOTER //
// src/App.vue